const DokoncanjePogodbView = () => import("@views/contract-completion/contract-completion-view.vue");
import DokoncanjePogodbe from "@views/contract-completion/contract-completion.vue";
import DokoncanjeDokumentacije from "@views/contract-completion/contract-completion-documentation.vue";
import DokoncanjeIdentifikacijaSisbon from "@views/contract-completion/contract-completion-sisbon.vue";
import DokoncanjeZakljucek from "@views/contract-completion/contract-completion-end.vue";
import { RouteLocationNormalizedLoaded } from "vue-router";

export const seznamDokoncanjePogodbRoutes = [
    {
        component: DokoncanjePogodbView,
        name: "dokoncanje_pogodbe_home",
        path: "dokoncanje",
        redirect: { name: "dokoncanje_dokumentacija" },
        children: [
            {
                component: DokoncanjePogodbe,
                name: "dokoncanje_pogodba",
                path: "pogodba",
                // beforeEnter: (to: RouteLocationNormalizedLoaded, from: RouteLocationNormalizedLoaded) => {
                //     if(from.name == undefined){
                //         return { name: "dashboard_dashboard" };
                //     }
                //     else{
                //         window.onbeforeunload = () => {
                //             return confirm();
                //         }
                //     }
                // },
            },            
            {
                component: DokoncanjeDokumentacije,
                name: "dokoncanje_dokumentacija",
                path: "dokumentacija",
                beforeEnter: (to: RouteLocationNormalizedLoaded, from: RouteLocationNormalizedLoaded) => {
                    if(from.name == undefined){
                        return { name: "dashboard_dashboard" };
                    }
                    else{
                        window.onbeforeunload = () => {
                            return confirm();
                        }
                    }
                },
            },
            {
                component: DokoncanjeIdentifikacijaSisbon,
                name: "dokoncanje_identifikacija",
                path: "identifikacija",
                beforeEnter: (to: RouteLocationNormalizedLoaded, from: RouteLocationNormalizedLoaded) => {
                    if(from.name == undefined){
                        return { name: "dashboard_dashboard" };
                    }
                    else{
                        window.onbeforeunload = () => {
                            return confirm();
                        }
                    }
                },
            },
            {
                component: DokoncanjeZakljucek,
                name: "dokoncanje_zakljucek",
                path: "zakljucek",
                beforeEnter: (to: RouteLocationNormalizedLoaded, from: RouteLocationNormalizedLoaded) => {
                    if(from.name == undefined){
                        return { name: "dashboard_dashboard" };
                    }
                    else{
                        window.onbeforeunload = () => {
                            return confirm();
                        }
                    }
                },
            },
        ]
    },
];
